import api from './Api';
import { AUTH_TOKEN_KEY } from '../constants';
import { goClient, loadLanguages } from './exportClient';

const OPTION_REQUEST_TIMEOUT_MS = 15000;
const client = () => {
  const c = api({ Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}` });
  c.defaults.timeout = OPTION_REQUEST_TIMEOUT_MS;
  return c;
};
const named = rows => (rows || []).map(r => ({ id: r.id, name: r.name }));

// Option loaders for the export modal's checklist boxes. Same endpoints the
// list screens' selects already call; each returns [{ id, name }].
export const loadBrands = keyword =>
  client().get('/admins/brands', { params: { keyword, active: 1, no_limit: 1 } }).then(({ data }) => named(data.data.data));

export const loadRarities = keyword =>
  client().get('/admins/rarities', { params: { keyword } }).then(({ data }) => named(data.data));

export const loadSubcategories = keyword =>
  client().get('/admins/subcategories', { params: { keyword, active: 1 } }).then(({ data }) => named(data.data));

export const loadVariantGroups = keyword =>
  client().get('/admins/variant-groups', { params: { keyword } }).then(({ data }) => named(data.data));

// Racks are filtered by name on the server, so the name is the id.
export const loadRacks = keyword =>
  client().get('/admins/sell_racks', { params: { keyword, no_limit: true } }).then(({ data }) => (data.data || []).map(r => ({ id: r.name, name: r.name })));

export const loadSellers = keyword =>
  client().get('/admins/users', { params: { keyword } }).then(({ data }) => (data.data.data || []).map(u => ({ id: u.id, name: u.email })));

// Sizes are matched by their US value (grade for cards), so the value is the id.
export const loadSizes = keyword =>
  client().get('/sizes', { params: { category: 'sneakers', ...(keyword ? { keyword } : {}) } }).then(({ data }) => (data.data || []).map(s => ({ id: s.US, name: s.US })));

// The groups route returns the whole (small) list; the search term narrows it here.
export const loadGroupOptions = keyword => {
  const q = (keyword || '').trim().toLowerCase();
  return goClient().get('/admins/vouchers/groups')
    .then(res => ((res.data && res.data.data) || []).map(g => ({ id: g, name: g })))
    .then(options => (q ? options.filter(o => o.name.toLowerCase().includes(q)) : options));
};

export const loadLanguageOptions = categoryId =>
  loadLanguages(goClient(), categoryId).then(codes => codes.map(c => ({ id: c, name: c })));
